import { ReloadOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import React from 'react';

const WarningPage: React.FC = () => (
  <Result
    status="warning"
    title="Warning"
    subTitle="There are some problems with your operation."
    extra={
      <Button
        icon={<ReloadOutlined />}
        type="primary"
        onClick={() => () => window.location.reload()}
      >
        Refresh
      </Button>
    }
  />
);

export default WarningPage;
